<dialog
  #dialog
  class="fixed inset-0 z-[1000] m-0 flex h-full max-h-none w-full max-w-none items-center justify-center overflow-y-auto border-0 bg-white px-3 pt-(--sat) pb-8 text-black dark:bg-[#171717] dark:text-white"
  aria-modal="true"
  tabindex="-1"
  [attr.aria-label]="
    (required ? 'FORCE_UPDATE_TITLE' : 'OPTIONAL_UPDATE_TITLE') | translate
  "
  (cancel)="onCancel($event)"
  (keydown)="$event.stopPropagation()"
>
  @if (!required) {
  <button
    type="button"
    class="absolute right-1.5 top-[calc(var(--sat)+12px)] flex size-5 items-center justify-center rounded-full hover:bg-black/10 dark:hover:bg-white/10"
    [attr.aria-label]="'CLOSE_MODAL' | translate"
    (click)="dismissIfOptional()"
  >
    <span
      class="block size-[18px] bg-black dark:bg-white mask-[url(/assets/images/icons/close.svg)] mask-size-[18px_18px]"
    ></span>
  </button>
  }
  <div
    class="my-auto flex w-full max-w-[340px] flex-col items-center text-center"
  >
    <img
      src="/assets/icons/gemster-icon-192.png"
      alt="Gemster"
      class="mb-3.5 size-15 rounded-[24%]"
    />
    <h1 class="mb-0 font-base text-lg font-bold">
      {{
        (required ? "FORCE_UPDATE_TITLE" : "OPTIONAL_UPDATE_TITLE") | translate
      }}
    </h1>
    <p class="mt-1.5 text-base text-balance text-black/80 dark:text-white/80">
      @if (required) {
      {{ "FORCE_UPDATE_REASON" | translate }}<br />
      {{ "FORCE_UPDATE_MESSAGE" | translate }}
      } @else {
      {{ "OPTIONAL_UPDATE_MESSAGE" | translate }}
      }
    </p>
    <a
      [href]="storeUrl"
      target="_blank"
      rel="noopener noreferrer"
      class="btn btn-primary mt-4.5 w-full"
      (click)="dismissIfOptional()"
    >
      {{ "FORCE_UPDATE_CTA" | translate }}
    </a>
    @if (!required) {
    <button
      type="button"
      class="mt-1.5 min-h-[44px] px-2 text-base underline underline-offset-4"
      (click)="dismissIfOptional()"
    >
      {{ "LATER" | translate }}
    </button>
    }
    <p class="mt-2 text-sm text-grey dark:text-lightGrey">
      {{ "VERSION" | translate }} {{ appVersion }}
    </p>
  </div>
</dialog>
